import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './DescriptionText.css';

export interface IDescriptionTextProps {
  text: string;
}

export const DescriptionText: React.VFC<IDescriptionTextProps> = ({ text }) => {
  return (
    <div className={styles['text']}>
      <UIText2 color="theme-white" textAlign="center">
        {text}
      </UIText2>
    </div>
  );
};
